<template>
  <div class="success-view">
    <v-icon v-if="status === 'success'" color="secondary"> $check </v-icon>
    <v-icon v-else-if="status === 'loading'" color="grey"> $loading </v-icon>
    <v-icon v-else color="error"> $error </v-icon>

    <h1 class="heading-two font-black success__heading">
      <template v-if="status === 'success'">
        Du wurdest erfolgreich von den Mail-Benachrichtigungen zu deinem gespeicherten Thema abgemeldet!
      </template>
      <template v-else-if="status === 'loading'">
        Deine Abmeldung wird verarbeitet...
      </template>
      <template v-else>
        Es gab einen Fehler bei der Abmeldung. Bitte versuche es später erneut.
      </template>
    </h1>

    <p class="font-large font-dark-grey success__text" v-if="status === 'success'">
      Wenn du es dir anders überlegt hast, dann setze die Glocke einfach erneut auf das gewünschte Thema.
    </p>

    <Button
      class="justify-center"
      :is-primary="true"
      label_text="Zurück zur Startseite"
      @click.native="goToHome()"
    />
  </div>
</template>

<script>
import Button from "@/components/Button";
import axios from "axios";

export default {
  name:"Unsubscribe",
  components: { Button },
  data() {
    return {
      status: "loading",
    };
  },
  async created() {
    const token = this.$route.query.token;
    if (!token) {
      this.status = "error";
      return;
    }

    try {
      //const baseUrl = process.env.VUE_APP_DOMAIN;
      //await axios.get(`${process.env.VUE_APP_DOMAIN}/api/unsubscribe`, {params: {token}});
      await axios.get(`/api/unsubscribe`, {params: {token}});
      this.status = "success";
    } catch (e) {
      this.status = "error";
    }
  },
  methods: {
    goToHome() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>